import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import LoggedPage from './components/LoggedPage';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

import ProtectedRoute from './components/ProtectedRoute';
import AdminPanel from './components/AdminPanel';
import reportWebVitals from './reportWebVitals';
import SharedState from './Hooks/SharedState';

ReactDOM.render(
  <React.StrictMode>
    <SharedState>
      <Router>
        <Routes>
          <Route path='/*' element={<App />} />
          <Route path='/audith' element={<ProtectedRoute><LoggedPage /></ProtectedRoute>} />
          <Route path='/admin' element={<ProtectedRoute requiredClaims={{ superAdmin: true }}><AdminPanel /></ProtectedRoute>} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />
        </Routes>
      </Router>
    </SharedState>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
